import { render, staticRenderFns } from "./ImportInstructions.vue?vue&type=template&id=9b89c61e"
import script from "./ImportInstructions.vue?vue&type=script&lang=js"
export * from "./ImportInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports